import { z } from 'zod';

export const PayoutsScalarFieldEnumSchema = z.enum(['id','stripe_id','status','amount','city_id','stripe_event_type','data','account_id','created_at','updated_at','rowTimestamp']);

export default PayoutsScalarFieldEnumSchema;
